import { OwnerState } from "../types/owner-edit";

export const BACKGROUND_SKIN_COLLECTION =
  process.env.NETWORK == "testnet"
    ? "EQD9m4-MjGQmw-4mAAGPdoLCE96voCx_DJe1orPx7bB0ER_U"
    : "";
export const NFT_SKIN_COLLECTION =
  process.env.NETWORK == "testnet"
    ? "EQAi3lbAUs60vE7IZFi_oEuRuQTcgLh0rtIcZViUosnIP_NN"
    : "";
export const WITHDRAW_LIMIT_BALANCE = 0.7;

export const OWNER_EDIT_CONSTANTS = {
  MAX_USERNAME_LENGTH: 50,
  MAX_INFO_LENGTH: 700,
  MAX_AVATAR_SIZE_MB: 2,
  MAX_BACKGROUND_SIZE_MB: 5,
  AVATAR_MAX_RESOLUTION: { width: 1024, height: 1024 },
  BACKGROUND_MAX_RESOLUTION: { width: 2880, height: 640 },
  NOTIFICATION_DURATION: 1000,
  DEFAULT_AVATAR: "/assets/owner-avatar.gif",
  DEFAULT_BACKGROUND: "/assets/owner-bg.gif",
} as const;

export const SOCIAL_PLATFORMS = {
  TELEGRAM: "telegram",
  ROCKET: "rocket",
  TWITTER: "twitter",
  GETGEMS: "getgems",
} as const;

export const STAT_TYPES = {
  CREATED: "Created",
  MINTED: "Minted",
  EARNED: "Earned",
} as const;

export const DEFAULT_OWNER_STATE: OwnerState = {
  extendInfo: null,
  username: "",
  avatar: "",
  avatarId: -1,
  background: "",
  backgroundId: -1,
  info: "",
  stats: [
    {
      title: STAT_TYPES.CREATED,
      subtitle: "COLLECTIONS",
      value: 0,
      isVisible: true,
    },
    { title: STAT_TYPES.MINTED, subtitle: "NFTs", value: 0, isVisible: true },
    { title: STAT_TYPES.EARNED, subtitle: "TON", value: 0, isVisible: true },
  ],
  socials: [
    { name: SOCIAL_PLATFORMS.TELEGRAM, link: "" },
    { name: SOCIAL_PLATFORMS.ROCKET, link: "" },
    { name: SOCIAL_PLATFORMS.TWITTER, link: "" },
    { name: SOCIAL_PLATFORMS.GETGEMS, link: "" },
  ],
};

export const ERROR_MESSAGES = {
  INVALID_URL: "Invalid URL format",
  UPLOAD_FAILED: "Upload failed",
  UPDATE_FAILED: "Update failed",
  DELETE_FAILED: "Delete failed",
  SAVE_FAILED: "Save failed",
  LOAD_FAILED: "Failed to load data",
  NETWORK_ERROR: "Network error occurred",
} as const;

export const SUCCESS_MESSAGES = {
  UPLOAD_SUCCESS: "Upload successful",
  UPDATE_SUCCESS: "Update successful",
  DELETE_SUCCESS: "Delete successful",
  SAVE_SUCCESS: "Save successful",
} as const;

export const VALIDATION_RULES = {
  USERNAME_MIN_LENGTH: 1,
  USERNAME_MAX_LENGTH: 50,
  INFO_MAX_LENGTH: 700,
  REQUIRED_FIELDS: ["username"] as const,
} as const;
